import ReactDOM from 'react-dom';

/** syntactic sugar for using JSX syntax with ReactDOM.createPortal */
const Portal = ({
  node = document.body,
  children,
}) => ReactDOM.createPortal(children, node);

export default Portal;
